import React from 'react'
import Parllex from '../component/Parllex';

export default function Research() {
  return (
    <div><Parllex/></div>
  )
}
